import { FieldErrors } from 'react-hook-form';

import { getAllWebEDIErrors } from 'services/webediErrors/utils';

const LINE_ITEM_IDENTIFIER_ERROR_PATTERN = /line_items\.\d+\..*\.identifiers\./;

export const hasLineItemIdentifierErrors = (errors: FieldErrors): boolean => {
  const allErrors = getAllWebEDIErrors(errors, {});
  return Object.keys(allErrors).some((path) => LINE_ITEM_IDENTIFIER_ERROR_PATTERN.test(path));
};
